import './PartList.css'
import React, {useEffect, useState} from 'react';
import { useConfig } from './ConfigContext';

const PartList = ({parts}) => {
    const [webglUrl, setWebglUrl] = useState("");
    const [selectedPartIndices, setSelectedPartIndices] = useState([]);
    const config = useConfig();

    useEffect(() => {
        if (config) {
            setWebglUrl(config["webgl_url"]);
        }
    }, [config]);

    const handlePartSelect = (part_index) => {
        setSelectedPartIndices(prevSelectedPartIndices => {
            if (prevSelectedPartIndices.includes(part_index)) {
                return prevSelectedPartIndices.filter(index => index !== part_index);
            } else {
                return [...prevSelectedPartIndices, part_index];
            }
        });
        window.webglIframe.contentWindow.postMessage({type: 'webgl_select_part', index: part_index + 1}, webglUrl);
    };

    return (
        <div className="part-list">
            <h4>Structure List</h4>
            <ul>
                {parts.map((part, index) => (
                    <li
                        key={index}
                        onClick={() => handlePartSelect(index)}
                        className={selectedPartIndices.includes(index) ? "selected" : ""}
                    >
                        <a>{part}</a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PartList;
